@switch (widget.widgetUIType) {
  @case (WidgetUIType.UpcomingTeams) {
    <app-upcoming-teams
      [widgetInfo]="widget"
      (addTeam)="addTeam.emit()"
    ></app-upcoming-teams>
  }
  @case (WidgetUIType.RecentlyAccepted) {
    <app-recent-accepts [widgetInfo]="widget"></app-recent-accepts>
  }
  @case (WidgetUIType.RecentFormResponses) {
    <app-recent-form-responses
      [widgetInfo]="widget"
    ></app-recent-form-responses>
  }
  @case (WidgetUIType.InProgressCredentialApplications) {
    <app-in-progress-applications
      [widgetInfo]="widget"
    ></app-in-progress-applications>
  }
  @case (WidgetUIType.LatestFormSubmissions) {
    <app-latest-form-submissions
      [widgetInfo]="widget"
    ></app-latest-form-submissions>
  }
}
